import { render, staticRenderFns } from "./UserEditTabPassword.vue?vue&type=template&id=6432c05c"
import script from "./UserEditTabPassword.vue?vue&type=script&lang=js"
export * from "./UserEditTabPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports